/* eslint-disable @stylistic/max-len */

export const headerTemplateDelta = `
<div class="ag-cell-label-container" role="presentation">
    <span data-ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>
    <div data-ref="eLabel" class="ag-header-cell-label" role="presentation">
      <span data-ref="icon" class="ag-header-custom-delta-icon" role="presentation">
        <svg viewBox="0 0 11 11" width="12" height="12" preserveAspectRatio="xMidYMid meet" >
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g transform="translate(-1507.000000, -303.000000)" fill="currentColor">
              <path d="M1517.38892,313.928948 L1507,313.928948 L1507,312.462281 L1516.28892,312.462281 L1512.4389,304.982281 L1508.71112,310.775614 L1507.73334,309.895614 L1512.01113,303.295614 C1512.25557,302.855614 1512.80557,302.928948 1512.98891,303.368948 L1517.87781,312.902281 C1518.18337,313.268948 1517.87781,313.928948 1517.38892,313.928948 Z" id="Path-Copy"></path>
            </g>
          </g>
        </svg>
      </span>
      <span data-ref="eText" class="ag-header-cell-text" role="columnheader"></span>
      <span data-ref="eFilter" class="ag-header-icon ag-filter-icon" aria-hidden="true"></span>
      <span data-ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>
      <span data-ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>
      <span data-ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>
      <span data-ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>
    </div>
</div>
`
